import { WelcomeComponentExtension } from './WelcomeComponent/WelcomeComponent';
import { Ae360LogoExtension } from './Ae360Logo';
import { UserPickerFieldExtension } from './UserPicker/UserPickerField';
import { MsUserPickerFieldExtension } from './MsUserPicker/MsUserPickerField';
import { UniqueEntityNamePickerFieldExtension } from './UniqueEntityPicker/UniqueEntityNamePicker';
import { PageWithGlobalSelectFieldExtension } from './PageWithGlobalSelect/PageWithGlobalSelect.tsx';

export function ae360ScaffolderExtensions() {
  return (
    <>
      <WelcomeComponentExtension />
      <Ae360LogoExtension />
      <UserPickerFieldExtension />
      <MsUserPickerFieldExtension />
      <UniqueEntityNamePickerFieldExtension />
      <PageWithGlobalSelectFieldExtension />
    </>
  );
}
